<template>

    <modal v-show="showModal"  @close="toggleAttachTeamPopup" :modalSize="'modal-md'" >
      <template v-slot:header>
      Attach Team
      </template>
      <template v-slot:body>
        <div class="card">
          <div class="card-body stretchable-modal-body">
            <div class="row">
              <div class="col-12">
                <p class="mb-1">
                  Member: <strong>{{ memberName }}</strong>
                </p>
                <p class="text-muted font-14">
                  Current team: {{ currentTeamName }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-4 col-md-4">
                <label
                    for="team_name"
                >
                  Team Name
                  <span class="text-danger"> *</span>
                </label>
              </div>
              <div class="col-lg-6 col-sm-6">
                <select
                    class="form-control"
                    id="team_name"
                    v-model="state.team_id"
                    v-if="search_teams.data"
                >
                  <option :value="undefined">Select Team</option>
                  <option
                      v-for="team in search_teams.data"
                      :key="team.team_id"
                      :value="team.team_id"
                  >
                    {{ team.team_name }}
                  </option>
                </select>
              </div>

          </div>
            <div class="col-lg-12" >
              <br>
              <div class="form-group text-center">
                <button
                    class="btn btn-primary mr-3"
                    :disabled="!state.team_id || state.saving"
                    :class="{ 'btn-secondary': !state.team_id || state.saving }"
                    @click="attachTeam"
                >
                  {{ state.saving ? "Attaching..." : "Attach" }}
                  <i class="fa fa-paper-plane"></i>
                </button>

                <button
                    class="btn btn-danger"
                    type="button"
                    @click="toggleAttachTeamPopup"
                >
                  Cancel
                </button>
              </div>
            </div>


        </div>
        </div>

      </template>
    </modal>
 </template>
<script>
import {defineComponent, computed, ref, reactive, onMounted} from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import _ from "lodash";

const team_module = "teams";
export default defineComponent({

  name: "AttachTeamModal",
  components: {},
  props: {
    showModal: {
      type: Boolean,
      default: true,
    },

    userData: {
      type: Object,
      required: true,
    },
    toggleEditCustomerTeamPopup: {
      type: Function,
      default: () => {},
    },
  },
  setup(props, context) {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    // the customer carries team_id and a `team` relation, not `teams`, so the
    // picker used to open blank even for a member who already has a team.
    const state = reactive({
      team_id: props.userData.team_id ?? props.userData.team?.team_id,
      saving: false,
    });
    const toggleAttachTeamPopup = () => {
      context.emit("toggleAttachTeamPopup");
    };

    const memberName = computed(
      () =>
        props.userData.full_name ??
        `${props.userData.first_name ?? ""} ${
          props.userData.last_name ?? ""
        }`.trim()
    );

    const currentTeamName = computed(
      () => props.userData.team?.team_name ?? "None"
    );
    async function fetchTeams() {

      // report=1 returns every team. paging this call hides the teams past the
      // first page from the picker, so staff on those teams cannot tag to them.
      let payload = { 'report': '1' };
      await store.dispatch(`${team_module}/fetchTeams`, payload)
    }
    function attachTeam(){

      if (!state.team_id || state.saving) {
        return;
      }

      let payload = {
        'team_id': state.team_id,
        'customer_id': props.userData.customer_id,

      };

      state.saving = true;

      store
        .dispatch(`${team_module}/attachCustomerToTeam`, payload)
        .then(() => {
          // the parent reloads the customer list as it closes this dialog
          toggleAttachTeamPopup();
        })
        .catch(() => {
          // the interceptor has toasted the reason; stay open so the choice is
          // still there to retry
          state.saving = false;
        });

    }
    onMounted(async() => {
      await fetchTeams();


    });

    return {
      state,
      memberName,
      currentTeamName,
      toggleAttachTeamPopup,
      search_teams : computed(() => store.getters[`${team_module}/teams`]),
      attachTeam
    };
  },
  });


</script>
